import '@corbieres/scss/app-front-page.scss';
import '@corbieres/js/bootstrap.bundle';
import Utils from '@corbieres/js/services/utils';
import Slider from '@corbieres/js/services/slider';
import Social from '@corbieres/js/services/social';
import Form from '@corbieres/js/services/form';
import FrontPage from '@corbieres/js/services/front-page';
import Menu from '@corbieres/js/services/menu';

document.addEventListener( "DOMContentLoaded", function () {

    // Utils
    Utils.click();
    Utils.tooltip();
    Utils.searchbox();
    Utils.smooth_scroll();
    Utils.lazy();
    Utils.obfuscation();
    Utils.hidding_nav();
    
    Form.input_focused();
    
    Social.ajax_instagram();
    
    new Menu();
    new Slider();
    new FrontPage();
})
